export function setExpiry() {
    const ttl = 86400000
    //const ttl = 5000
    const now = new Date()

    const expiry = now.getTime() + ttl

    localStorage.setItem('expiry', JSON.stringify(expiry))
}

export function getExpiry() {
    let expiry = null

    if (localStorage.getItem('expiry') !== null) {
        expiry = JSON.parse(localStorage.getItem('expiry'))
    }

    return expiry
}

function checkExpiration() {
    const now = new Date()
    const expiry = getExpiry()

    const isExpired = now.getTime() > expiry

    return isExpired
}

export function getRememberMe() {
    //let rememberMe = false
    let rememberMe = JSON.parse(localStorage.getItem('rememberMe'))

    if (localStorage.getItem('rememberMe') !== null) {
        console.info(localStorage.getItem('rememberMe'))
        rememberMe = JSON.parse(localStorage.getItem('rememberMe'))
    }

    return rememberMe
}

export function setRememberMe(remember) {
    localStorage.setItem('rememberMe', JSON.stringify(remember))
}

export function getUsername() {
    let rememberMe = JSON.parse(localStorage.getItem('username'))

    if (localStorage.getItem('username') !== null) {
        console.info(localStorage.getItem('username'))
        rememberMe = JSON.parse(localStorage.getItem('username'))
    }

    return rememberMe
}

export function setUsername(username) {
    localStorage.setItem('username', JSON.stringify(username))
}

export function removeUsername() {
    localStorage.removeItem('username')
}

export function getPortal() {
    let portal = null

    if (localStorage.getItem('portal') !== null) {
        portal = JSON.parse(localStorage.getItem('portal'))
    }

    return portal
}

export function setPortal(portal) {
    localStorage.setItem('portal', JSON.stringify(portal))
}

export function removePortal() {
    localStorage.removeItem('portal')
}

export function setMasterLocationId(masterLocationId) {
    localStorage.setItem('masterLocationId', JSON.stringify(masterLocationId))
}

export function removeMasterLocationId() {
    localStorage.removeItem('masterLocationId')
}

export function getLocations() {
    let locations = null

    if (localStorage.getItem('locations') !== null && !checkExpiration()) {
        locations = JSON.parse(localStorage.getItem('locations'))
    }

    return locations
}

export function setLocations(locations) {
    setExpiry()
    localStorage.setItem('locations', JSON.stringify(locations))
}

export function getReportLocations() {
    let locations = null
	console.info({locations})
    if (localStorage.getItem('reportLocations') !== null) {
        locations = JSON.parse(localStorage.getItem('reportLocations'))
		console.info({locations})
    }

	console.info({locations})

    if (locations === null) return locations

    locations.sort((a, b) =>
        a.name.localeCompare(
            b.name,
            navigator.languages[0] || navigator.language,
            {
                numeric: true,
                ignorePunctuation: true,
            }
        )
    )

    return locations
}

export function setReportLocations(locations) {
    localStorage.setItem('reportLocations', JSON.stringify(locations))
}

export function removeReportLocations() {
    localStorage.removeItem('reportLocations')
}

export function setSelectedLocations(selectedLocations) {
    localStorage.setItem('selectedLocations', JSON.stringify(selectedLocations))
}

export function removeLocations() {
    localStorage.removeItem('locations')
}

export function removeSelectedLocations() {
    localStorage.removeItem('selectedLocations')
}

export function setAuthentication({ authInfo }) {
	sessionStorage.setItem('auth', JSON.stringify(authInfo))
}

export function getAuthentication() {
    let auth = null

	if (sessionStorage.getItem('auth') !== null) {
        auth = JSON.parse(sessionStorage.getItem('auth'))
    }

    return auth
}

export function removeAuthentication() {
	sessionStorage.removeItem('auth')
}

export function renewAuthentication() {
	let authInfo = getAuthentication()
	
	if (authInfo == null){
		return false
	} else {
		let expiration = new Date()
		expiration.setHours(expiration.getHours() + 12)
		authInfo.expiration = expiration.getTime()
		
		setAuthentication({authInfo})
		return true
	}
}

export function getOwner() {
    let owner = {
        name: '',
        id: '',
        portalUser: '',
    }

    if (localStorage.getItem('owner') !== null) {
        owner = JSON.parse(localStorage.getItem('owner'))
    }

    return owner
}

export function setOwner({ owner }) {
    localStorage.setItem('owner', JSON.stringify(owner))
}

export function removeOwner() {
    localStorage.removeItem('owner')
}

export function getDataRefreshDate() {
    let dataRefreshDate = JSON.parse(localStorage.getItem('dataRefreshDate'))

    if (localStorage.getItem('dataRefreshDate') !== null) {
        dataRefreshDate = JSON.parse(localStorage.getItem('dataRefreshDate'))
    }

    return dataRefreshDate
}

export function setDataRefreshDate(dataRefreshDate) {
    localStorage.setItem('dataRefreshDate', JSON.stringify(dataRefreshDate))
}

export function getReportSelections() {
    let reportSelections = JSON.parse(localStorage.getItem('reportSelections'))

    if (localStorage.getItem('reportSelections') !== null) {
        reportSelections = JSON.parse(localStorage.getItem('reportSelections'))
    }

    return reportSelections
}

export function setReportSelections(reportSelections) {
    localStorage.setItem('reportSelections', JSON.stringify(reportSelections))
}